import React from "react";
import axios from "axios";
import { Typography } from "@material-tailwind/react";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import { FcCancel } from "react-icons/fc";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { useState, useEffect } from "react";
import Loading from "../../../COMPONENTS/Loading/Loading";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { RxDotsVertical } from "react-icons/rx";
import {
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import SidebarTop from "../../SidebarTop";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";



const TABLE_ROWS = [
  {
    name: "Koukou marie",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    SiteTouristique: "Ticket visite musée",
    Arrive: "22/10/2024",
    Heure: "8",
    personne: "100",
    tarif: "8000",
    Paiement: "Payé",
  },
  {
    name: "Koukou marie",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    SiteTouristique: "Ticket cinema",
    Arrive: "22/10/2024",
    Heure: "8",
    personne: "100",
    tarif: "8000",
    Paiement: "Payé",
  },
  {
    name: "Koukou marie",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    SiteTouristique: "Ticket visite musée",
    Arrive: "22/10/2024",
    Heure: "8",
    personne: "100",
    tarif: "8000",
    Paiement: "Payé",
  },
  {
    name: "Koukou marie",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    SiteTouristique: "Ticket cinema",
    Arrive: "22/10/2024",
    Heure: "8",
    personne: "100",
    tarif: "8000",
    Paiement: "Payé",
  },
  {
    name: "Koukou marie",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    SiteTouristique: "Ticket de concert",
    Arrive: "22/10/2024",
    Heure: "8",
    personne: "100",
    tarif: "8000",
    Paiement: "Payé",
  },
];

function Liste() {
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  localStorage.setItem(
    "url",
    JSON.stringify("/Dashboard/Reservation/Loisir/Liste")
  );

  const [records, setRecords] = useState([]);

  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });

  ///////////////////// début pagination ////////////////////
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(4); //le nombre d'éléments à afficher par page
  // Calcul du nombre total de pages
  const totalPages = Math.ceil(records.length / itemsPerPage);

  // Récupération des enregistrements pour la page actuelle
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = records.slice(startIndex, endIndex);

  // Fonctions pour naviguer entre les pages
  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  ///////////////////// fin pagination ////////////////////

  const changeStatut = (id) => {
    //console.log("ghhhhh")
    async function ChangeStatutHerb() {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/reservation/loisire/change/statut`,
          { id: id }
        );
        if (res.data.status === 201) {
          window.location.reload();
          toast.success(res.data.message);
          //console.log(res);
        } else {
          toast.error(res.data.message);
          console.log(res);
        }
      } catch (err) {
        console.log(err);
      }
    }
    ChangeStatutHerb();
  };

  useEffect(() => {
    if (!data) {
      navigate("/Connexion");
    }

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/loisir/reservation/list/${data.userId}`
      )
      .then((response) => {
        setRecords(response.data.data);
        //console.log(response.data.data)
      })
      .catch((err) => console.log(err));

    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, []);

  const {t} = useTranslation()
  const TABLE_HEAD = ["Action","Statut", t("Client"),"Site",t("Date et Heure Arrivée"),t("Hôtes"),t("Tarif"),];

  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          <div className="w-screen h-screen barre_scroll">
            {/* sidebar top  */}
            <SidebarTop />
            <div>
              <ToastContainer />
            </div>
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  {t("Les reservations")}
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Loisirs & Activités")}
                </Link>
              </Breadcrumbs>
            </div>

            {/* container formulaire */}
            <div className="flex justify-center md:p-10 s:p-4">
              <Card className="h-full w-full border-t-8 border-[#fe7f2d] ">
                <CardHeader
                  floated={false}
                  shadow={false}
                  className="rounded-none"
                >
                  <Typography
                    className="font-semibold md:text-xl s:text-lg"
                    color="blue-gray"
                  >
                    {t("Liste des personnes qui ont acheté un ticket")}
                  </Typography>
                </CardHeader>
                <CardBody className="px-0 overflow-scroll">
                  <table className="w-full mt-4 overflow-scroll text-left table-auto min-w-max">
                    <thead>
                      <tr>
                        {TABLE_HEAD.map((head, index) => (
                          <th
                            key={head}
                            className="p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50"
                          >
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                            >
                              {head}{" "}
                              {index !== TABLE_HEAD.length - 1 && (
                                <ChevronUpDownIcon
                                  strokeWidth={2}
                                  className="w-4 h-4"
                                />
                              )}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    {records.length === 0 && (
                      <tbody>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="flex items-center font-normal"
                        >
                          {t("Pas de donnees")}
                        </Typography>
                      </tbody>
                    )}
                    {records.length > 0 && (
                      <tbody>
                        {currentItems.map((list, index) => {
                          const isLast = index === list.length - 1;
                          const classes = isLast
                            ? "p-4"
                            : "p-4 border-b border-blue-gray-50";

                          return (
                            <tr key={index} className="hover:bg-slate-100">
                              <td className={classes}>
                                <div className="flex items-center space-x-2 ">
                                  <div className="flex flex-col">
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal"
                                    >
                                      {list.Names} {list.LastName}
                                    </Typography>
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal opacity-70"
                                    ></Typography>
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal opacity-70"
                                    >
                                      {list.Phones}
                                    </Typography>
                                  </div>
                                </div>
                              </td>
                              <td className={classes}>
                                <div className="flex flex-col">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.title_announce}
                                  </Typography>
                                </div>
                              </td>
                              <td className={classes}>
                                <div className="flex flex-col">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.starting_date}
                                  </Typography>
                                </div>
                              </td>

                              <td className={classes}>
                                <div className="w-max">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.quantities} personne(s)
                                  </Typography>
                                </div>
                              </td>
                              <td className={classes}>
                                <div className="w-max">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {list.price_announce} XOF
                                  </Typography>
                                </div>
                              </td>
                              <td className={classes}>
                                <Tooltip content="Action sur la publication">
                                  <IconButton variant="text">
                                    <Menu>
                                      <MenuHandler>
                                        <IconButton>
                                          <RxDotsVertical />
                                        </IconButton>
                                      </MenuHandler>
                                      <MenuList className="flex flex-col gap-2">
                                        {/* Refuser */}
                                        {list.status === 1 && (
                                          <MenuItem
                                            onClick={() =>
                                              changeStatut(list.id_announce)
                                            }
                                            className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100"
                                          >
                                            <FcCancel className="text-lg" />
                                            <div className="flex flex-col gap-1">
                                              <Typography
                                                variant="small"
                                                color="gray"
                                                className="font-semibold"
                                              >
                                                {t("Refuser")}
                                              </Typography>
                                            </div>
                                          </MenuItem>
                                        )}
                                        {list.status === 0 && (
                                          <MenuItem
                                            onClick={() =>
                                              changeStatut(list.id_announce)
                                            }
                                            className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100"
                                          >
                                            {/* <IoIosEye className='text-lg' /> */}
                                            <div className="flex flex-col gap-1">
                                              <Typography
                                                variant="small"
                                                color="gray"
                                                className="font-semibold"
                                              >
                                                {t("Accepter")}
                                              </Typography>
                                            </div>
                                          </MenuItem>
                                        )}
                                      </MenuList>
                                    </Menu>
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal"
                                >
                                  {list.status === 1
                                    ? t("Réservation acceptée")
                                    : t("Réservation rejetée")}
                                </Typography>
                              </td>
                             
                            </tr>
                          );
                        })}
                      </tbody>
                    )}
                  </table>
                </CardBody>
                <CardFooter className="flex items-center justify-between p-4 border-t border-blue-gray-50">
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal"
                  >
                    Page {currentPage} of {totalPages}
                  </Typography>
                  <div className="flex gap-2">
                    <Button
                      onClick={prevPage}
                      disabled={currentPage === 1}
                      variant="outlined"
                      size="sm"
                    >
                      {t("Previous")}
                    </Button>
                    <Button
                      onClick={nextPage}
                      disabled={currentPage === totalPages}
                      variant="outlined"
                      size="sm"
                    >
                      {t("Next")}
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Liste;
